import React from "react";

export function Hero({ onCta }: { onCta: () => void }) {
  return (
    <section className="relative pt-[130px] pb-[70px] text-center">
      {/* Radial glow */}
      <div className="absolute top-[45%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(0,240,160,0.06) 0%, rgba(167,139,250,0.03) 40%, transparent 70%)" }}
      />

      <div className="relative z-10">
        {/* Brain-arc logo */}
        <div className="flex justify-center mb-8">
          <svg viewBox="0 0 52 52" fill="none" className="w-20 h-20">
            <circle cx="26" cy="26" r="24" stroke="#00F0A0" strokeWidth="1.5" fill="none" opacity="0.2"/>
            <path className="arc-draw" d="M16 20 C16 14, 22 12, 26 12 C30 12, 36 14, 36 20" stroke="#00F0A0" strokeWidth="2.2" strokeLinecap="round" fill="none"/>
            <path className="arc-draw" d="M14 28 C14 22, 18 18, 26 18 C34 18, 38 22, 38 28" stroke="#00F0A0" strokeWidth="2.2" strokeLinecap="round" fill="none"/>
            <path className="arc-draw" d="M18 36 C18 30, 22 26, 26 26 C30 26, 34 30, 34 36" stroke="#00F0A0" strokeWidth="2.2" strokeLinecap="round" fill="none"/>
            <circle className="node-pulse" cx="16" cy="20" r="2.8" fill="#00F0A0"/>
            <circle className="node-pulse" cx="36" cy="20" r="2.8" fill="#00F0A0"/>
            <circle className="node-pulse" cx="26" cy="18" r="2.2" fill="#00F0A0"/>
            <circle className="node-pulse" cx="14" cy="28" r="2.2" fill="#00F0A0"/>
            <circle className="node-pulse" cx="38" cy="28" r="2.2" fill="#00F0A0"/>
            <circle className="node-pulse" cx="26" cy="26" r="2.8" fill="#00F0A0"/>
            <circle className="node-pulse" cx="18" cy="36" r="1.8" fill="#00F0A0"/>
            <circle className="node-pulse" cx="34" cy="36" r="1.8" fill="#00F0A0"/>
          </svg>
        </div>

        {/* Title */}
        <h1 className="font-display font-black text-6xl sm:text-[76px] tracking-[-3px] leading-none mb-5">
          neurobics<span className="text-electric-mint">.io</span>
        </h1>

        {/* Tagline */}
        <p className="font-mono text-[13px] text-warm-gray tracking-[1px] leading-relaxed mb-10 max-w-md mx-auto">
          Five daily brain games. Train spatial reasoning,<br />
          pattern recognition & logical thinking.
        </p>

        {/* CTA */}
        <button
          onClick={onCta}
          className="font-display font-bold text-base px-9 py-4 rounded-[12px] bg-electric-mint text-midnight hover:bg-[#33FFB8] hover:-translate-y-[1px] transition-all duration-200"
          style={{ boxShadow: "0 0 20px rgba(0,240,160,0.25)" }}
        >
          Start Your Daily Five
        </button>
      </div>
    </section>
  );
}
